import React from 'react'
import PropTypes from 'prop-types'

/**
 * Generic React error boundary for any deck.gl / WebGL surface. The pre-mount
 * `getCanRenderIconLayer()` probe catches most broken driver/GPU combos before
 * mount, but if deck.gl throws *during* atlas creation or texture upload after
 * first paint, this boundary swaps in the consumer-supplied DOM fallback for
 * the rest of the session.
 *
 * Used by every `Adaptive*` WebGL marker wrapper (route manager, configured
 * services, bulk actions). Pass the DOM equivalent as `fallback`.
 */
class WebGLLayerErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn('[WebGLLayerErrorBoundary] WebGL render failed, falling back:', error)
  }

  render() {
    if (this.state.hasError) return this.props.fallback
    return this.props.children
  }
}

WebGLLayerErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node.isRequired,
}

export default WebGLLayerErrorBoundary
